import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { JobFunctionOptionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const jobFunctionOptions = graphql(`
  query jobFunctionOptions {
    jobFunctionOptions {
      value
      label
    }
  }
`);

/**
 * Backend-served value/label options for the unified job-function filter — the single source of
 * truth lives in `@stotles/data` `job-function/taxonomy.ts` (`not_specified` excluded). Rarely
 * changes → cached forever.
 */
export function useJobFunctionOptions(
  options?: UseQueryOptions<JobFunctionOptionsQuery, unknown, JobFunctionOptionsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["jobFunctionOptions"],
    jobFunctionOptions,
    [undefined],
    { staleTime: Infinity, ...options },
  );
  return { data: data?.jobFunctionOptions, ...rest };
}
